import { Action, createReducer, on } from '@ngrx/store';
import { emptyCreditCard } from 'src/app/constants/empty-credit-card';
import { PaymentState } from './payment.state';
import { paymentCardLoadSucceeded, paymentInvoiceLoadSucceeded, paymentLoad, paymentToggleInvoice } from './payment.actions';
import { CreditCard } from '../../models/credit-card';
import { toggle } from '../../utils/array-reducer';

const initialState: PaymentState = {
    payableInvoices: [],
    creditCards: [],
    newCreditCard: emptyCreditCard,
    selectedCardId: null,
    selectedInvoiceIds: [],
    paymentAmount: 0,
    processing: false,
    message: null,
    loadingInvoices: false,
    loadingCards: false
};

function defaultCard(cards: CreditCard[]): string {
    if (cards.length > 0) {
        const card = cards.find(c => c.default);
        if (card) {
            return card ? card.id : cards[0].id;
        }
    }
    return null;
}

const reducer = createReducer(
    initialState,
    on(paymentLoad, () => ({ ...initialState, loadingInvoices: true, loadingCard: true })),
    on(paymentCardLoadSucceeded, (state, { creditCards }) => ({
        ...state,
        creditCards: [ ...creditCards ],
        selectedCardId: defaultCard(creditCards),
        loadingCards: false
    })),
    on(paymentInvoiceLoadSucceeded, (state, { invoices }) => ({
        ...state,
        payableInvoices: [ ...invoices ],
        selectedInvoiceIds: invoices.map(i => i.id),
        loadingInvoices: false
    })),
    on(paymentToggleInvoice, (state, { invoiceId }) => ({
        ...state,
        selectedInvoiceIds: toggle(state.selectedInvoiceIds, invoiceId)
    }))
);

export function paymentReducer(state: PaymentState | undefined, action: Action): any {
    return reducer(state, action);
}
